import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {SectionPadding} from '@/section';
import PictureWrapper from '@/ui/images-wrapper';
import {H2, PNoMargin} from '@/typography';
import {withBgNeutral200} from '@/hocs/withColors';
import {withBoldWeight, withSecondaryFontTestimonial} from '@/hocs/withFontType';
import {withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import sharedStyles from '../../industry-shared/customer-stories-section.module.scss';
import styles from './customer-stories-section.module.scss';

const Neutral200Section = withBgNeutral200(SectionPadding);
const QuoteP = withSecondaryFontTestimonial(PNoMargin);
const NameP = withBoldWeight(PNoMargin);
const TestimonialCol = withMarginBottomZeroToLg(Col);

const imgPath = '/static/images/industry-technology/';

type Testimonial = {
  imageUrl: string;
  imageAlt: string;
  quote: string;
  nameTitle: string;
  company: string;
};

/** Grid forwards `children` via createProps; PropTypes-only export omits it from types. */
const FluidGrid = Grid as React.ComponentType<{
  fluid?: boolean;
  className?: string;
  tagName?: string;
  children?: React.ReactNode;
}>;

const CustomerStoriesSection = () => {
  const t = useTranslations('industryTechnology.customerStories');
  const testimonials = t.raw('testimonials') as Testimonial[];

  return (
    <Neutral200Section>
      <Container>
        <FluidGrid fluid>
          <H2 className={styles.title}>{t('title')}</H2>

          <Row center="xs" start="md" className={sharedStyles['cards-row']}>
            {testimonials.map(testimonial => (
              <TestimonialCol key={testimonial.company} xs={12} md={4}>
                <article className={styles.card}>
                  <div className={styles.media}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl={testimonial.imageUrl}
                      imageTypeFallback="jpg"
                      altImage={testimonial.imageAlt}
                      className={styles.image}
                      loading="lazy"
                    />
                  </div>

                  <div className={styles.content}>
                    <QuoteP className={styles.quote}>{testimonial.quote}</QuoteP>
                    <NameP className={styles.name}>{testimonial.nameTitle}</NameP>
                    <PNoMargin className={styles.company}>{testimonial.company}</PNoMargin>
                  </div>
                </article>
              </TestimonialCol>
            ))}
          </Row>
        </FluidGrid>
      </Container>
    </Neutral200Section>
  );
};

export default CustomerStoriesSection;
